import { api } from '@/shared/api';
import { API_ENDPOINTS } from '@/constants/api';
import { normalizePaginatedResponse } from '@/shared/api/pagination';
import type { PaginatedApiResponse } from '@/shared/api/pagination';
import type { PaginatedResponse } from '@/shared/types/entity';
import type { BlockedMTORequest } from '../types';

export const blockedMTOsApi = {
  getList: async (params?: {
    page?: number;
    perPage?: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<PaginatedResponse<BlockedMTORequest>> => {
    const response = await api.get<PaginatedApiResponse<BlockedMTORequest>>(
      API_ENDPOINTS.BLOCKED_MTO_REQUESTS.LIST,
      {
        params,
      },
    );
    return normalizePaginatedResponse(response.data);
  },
};
